import React from "react";
import { IIcon } from "./icons.types";

const HorizontalLoader = ({
  width = 128,
  height = 128,
  color = "currentColor"
}: IIcon): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid">
      <g transform="translate(20 50)">
        <circle r="4" fill={color}>
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="-0.4934210526315789s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1.3157894736842106s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
      <g transform="translate(40 50)">
        <circle r="4" fill={color}>
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="-0.32894736842105265s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1.3157894736842106s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
      <g transform="translate(60 50)">
        <circle r="4" fill={color}>
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="-0.16447368421052633s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1.3157894736842106s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
      <g transform="translate(80 50)">
        <circle r="4" fill={color}>
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="0s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1.3157894736842106s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </svg>
  );
};

export { HorizontalLoader };
